import { Controller } from "@hotwired/stimulus"

// Mobile Funnel-Leiste der Produkt-Pillars (nicht sticky_cta: das ist die
// Rechner-Ergebnisseite mit umgekehrter Logik). Eingeblendet, sobald der Sentinel (der Schnell-Check)
// nach oben aus dem Viewport gescrollt ist; solange er sichtbar oder noch
// unterhalb ist, bleibt die Leiste weg, damit sie die Check-Buttons nicht
// verdeckt. Scroll-Listener statt IntersectionObserver: Bei Sprüngen per
// Anker oder Rail wandert der Sentinel von "unterhalb" nach "oberhalb", ohne
// je zu schneiden, und der Observer würde nie feuern.
export default class extends Controller {
  static values = { sentinel: String }
  static targets = ["bar"]

  connect() {
    this.sentinel = document.getElementById(this.sentinelValue)
    if (!this.sentinel) return
    this.ticking = false
    this.onScroll = () => this.requestUpdate()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
  }

  requestUpdate() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.ticking = false
      this.update()
    })
  }

  update() {
    // Am Seitenende ausblenden, damit Impressum/Datenschutz im Footer erreichbar bleiben
    const nearEnd = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 96
    const show = this.sentinel.getBoundingClientRect().bottom < 0 && !nearEnd
    this.barTarget.classList.toggle("translate-y-full", !show)
    this.barTarget.toggleAttribute("inert", !show)
    this.barTarget.setAttribute("aria-hidden", show ? "false" : "true")
    this.barTarget.dataset.visible = show ? "1" : "0"
  }
}
